var React = require('react');

function Add (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Add.defaultProps = {"fill":"#777777","height":"15px","viewBox":"0 0 24 24","width":"24px"};

module.exports = Add;

Add.default = Add;
